module.exports = __webpack_public_path__ + "static/scale-model-of-paulson-house-in-san-jose-california-6c797f41930fa271b55b48710f401d79.png";